
import { useState, useEffect } from 'react';
import { useToast } from "@/hooks/use-toast";
import { Article } from "@/components/reader-home/types";
import { supabase } from "@/integrations/supabase/client";
import { articleService } from '@/services/article';
import { transformDatabaseArticleToUiArticle } from '@/utils/articleTransformUtils';

export const useTaggedArticles = (tagName?: string | null) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchArticles = async () => {
      if (!tagName) {
        setArticles([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        // Use the articleService to get articles by tag
        const { data, error } = await articleService.getArticlesByTag(tagName);

        if (error) throw error;

        if (data) {
          // Transform the articles using our utility function
          const transformedArticles: Article[] = data.map((article: any) => 
            transformDatabaseArticleToUiArticle(article)
          );

          setArticles(transformedArticles);
        }
      } catch (err) {
        console.error('Error fetching tagged articles:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch articles'));
        toast({
          title: "Error",
          description: "Failed to load articles. Please try again.",
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [tagName, toast]);

  return { articles, loading, error };
};
